import React from 'react';
import { TIconProps } from '../types';

function RefreshIcon({ fill = 'currentColor', className = '', ariaHidden = true }: TIconProps) {
  return (
    <svg
      className={className}
      width="14"
      height="14"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={ariaHidden}
      focusable={false}
    >
      <path
        d="M13.65 2.35A7.958 7.958 0 0 0 8 0C3.58 0 .01 3.58.01 8S3.58 16 8 16c3.73 0 6.84-2.55 7.73-6h-2.08A5.99 5.99 0 0 1 8 14 6 6 0 0 1 2 8a6 6 0 0 1 6-6c1.66 0 3.14.69 4.22 1.78L9 7h7V0l-2.35 2.35z"
        fill={fill}
      />
    </svg>
  );
}

export default RefreshIcon;
